/* CLUB LUCHADOR — theme.js (sin dependencias) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isMobile = window.matchMedia('(max-width: 749px)');

  /* ---------- Header: transparente sobre el video, sólido al bajar ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var waButton = document.querySelector('.wa-button');

    if (header.hasAttribute('data-overlay')) {
      var hero = document.querySelector('[data-hero]');
      var update = function () {
        var limit = hero ? hero.offsetHeight - header.offsetHeight - 10 : 40;
        var solid = window.scrollY > limit;
        header.classList.toggle('is-solid', solid);
        if (waButton) waButton.classList.toggle('is-visible', solid);
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    } else if (waButton) {
      waButton.classList.add('is-visible');
    }

    var toggle = header.querySelector('[data-menu-toggle]');
    var menu = header.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var close = function () {
      menu.hidden = true;
      header.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
    };
    var open = function () {
      menu.hidden = false;
      header.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      var first = menu.querySelector('a');
      if (first) first.focus();
    };
    toggle.addEventListener('click', function () {
      menu.hidden ? open() : close();
    });
    menu.querySelectorAll('[data-menu-link]').forEach(function (link) {
      link.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { close(); toggle.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) { if (e.matches) close(); });
  }

  /* ---------- Hero video ---------- */
  function initHero() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var wrappers = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-video]'));
    var toggle = hero.querySelector('[data-hero-toggle]');
    if (!wrappers.length) return;

    var activeVideo = null;

    function pickWrapper() {
      var mobileWrap = hero.querySelector('.hero__video--mobile');
      var desktopWrap = hero.querySelector('.hero__video--desktop');
      if (isMobile.matches && mobileWrap) return mobileWrap;
      return desktopWrap || mobileWrap;
    }

    function stopAll() {
      wrappers.forEach(function (w) {
        var v = w.querySelector('video');
        if (v) v.pause();
        w.classList.remove('is-playing');
      });
    }

    function play() {
      stopAll();
      var wrap = pickWrapper();
      if (!wrap) return;
      var video = wrap.querySelector('video');
      if (!video) return;
      activeVideo = video;
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.loop = true;
      video.removeAttribute('controls');
      video.preload = 'auto';
      var p = video.play();
      var onPlaying = function () { wrap.classList.add('is-playing'); };
      video.addEventListener('playing', onPlaying, { once: true });
      if (p && p.catch) p.catch(function () { wrap.classList.remove('is-playing'); });
      setToggle(false);
    }

    function setToggle(paused) {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.querySelector('[data-label-pause]').hidden = paused;
      toggle.querySelector('[data-label-play]').hidden = !paused;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (activeVideo && !activeVideo.paused) {
          activeVideo.pause();
          setToggle(true);
        } else {
          play();
        }
      });
    }

    if (reduceMotion.matches) {
      // Respeta movimiento reducido: solo imagen de respaldo, el visitante puede iniciar el video.
      setToggle(true);
    } else {
      play();
    }

    isMobile.addEventListener('change', function () { if (!reduceMotion.matches) play(); });

    // Pausa cuando el hero sale de pantalla para ahorrar batería.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!activeVideo) return;
          if (entry.isIntersecting) {
            if (toggle && toggle.getAttribute('aria-pressed') === 'true') return;
            activeVideo.play().catch(function () {});
          } else {
            activeVideo.pause();
          }
        });
      }, { threshold: 0.05 }).observe(hero);
    }
  }

  /* ---------- Horarios: pestañas por día + filtro ---------- */
  function initSchedules() {
    document.querySelectorAll('[data-schedule]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      if (!tabs.length) return;
      var current = 'all';

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== tab.getAttribute('data-day'); });
        if (focus) tab.focus();
        applyFilter();
      }

      function applyFilter() {
        panels.forEach(function (p) {
          var cards = p.querySelectorAll('[data-discipline]');
          var visible = 0;
          cards.forEach(function (c) {
            var show = current === 'all' || c.getAttribute('data-discipline') === current;
            c.hidden = !show;
            if (show) visible++;
          });
          var empty = p.querySelector('[data-filter-empty]');
          if (empty) empty.hidden = !(cards.length && visible === 0);
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight') idx = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') idx = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') idx = 0;
          if (e.key === 'End') idx = tabs.length - 1;
          if (idx !== null) { e.preventDefault(); select(tabs[idx], true); }
        });
      });

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          current = btn.getAttribute('data-filter');
          filters.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          applyFilter();
        });
      });

      // Día de hoy por defecto (si está visible), si no el primero.
      var keys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var today = keys[new Date().getDay()];
      var initial = tabs.filter(function (t) { return t.getAttribute('data-day') === today; })[0] || tabs[0];
      select(initial, false);
    });
  }

  /* ---------- Variantes: actualizar precio visible ---------- */
  function initVariantSelects() {
    document.querySelectorAll('[data-variant-select]').forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = '1';
      var form = select.closest('form');
      var scope = select.closest('.plan, .product__info, .annual');
      var target = scope ? scope.querySelector('[data-price-target]') : null;
      var btn = form ? form.querySelector('button[type="submit"]') : null;
      var msg = form ? form.querySelector('[data-unavailable-msg]') : null;
      var update = function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (target && opt.dataset.price) target.textContent = opt.dataset.price;
        var ok = !opt.value || opt.dataset.available !== 'false';
        if (btn) {
          btn.disabled = !ok;
          btn.textContent = ok ? btn.dataset.label : btn.dataset.soldOutLabel;
        }
        if (msg) msg.hidden = ok;
      };
      select.addEventListener('change', update);
      update();
    });
  }

  /* ---------- Matrícula para socios nuevos ---------- */
  function initEnrollment() {
    var dialog = document.getElementById('EnrollmentDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return; // sin <dialog>: el formulario se envía normal
    var enrollmentId = dialog.getAttribute('data-enrollment-variant'); // string: nunca se convierte a Number
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var errorEl = dialog.querySelector('[data-enrollment-error]');
    var yesBtn = dialog.querySelector('[data-enrollment-yes]');

    document.querySelectorAll('form[data-ask-enrollment]').forEach(function (form) {
      if (form.dataset.enrollmentBound) return;
      form.dataset.enrollmentBound = '1';
      form.addEventListener('submit', function (e) {
        if (form.dataset.enrollmentDone === '1') return;
        e.preventDefault();
        dialog._pf = form;
        if (errorEl) errorEl.hidden = true;
        dialog.showModal();
      });
    });

    if (dialog.dataset.bound) return;
    dialog.dataset.bound = '1';

    function finish() {
      var after = dialog._pf && dialog._pf.getAttribute('data-after-add') === 'checkout' ? 'checkout' : 'cart';
      window.location.href = root + after;
    }

    yesBtn.addEventListener('click', function () {
      if (!dialog._pf) return;
      yesBtn.classList.add('is-loading');
      var planData = new FormData(dialog._pf);
      planData.delete('return_to');
      var enrollData = new FormData();
      enrollData.append('id', enrollmentId);
      enrollData.append('quantity', '1');

      var post = function (body) {
        return fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (r.ok) return r;
            return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || ''); });
          });
      };
      post(planData)
        .then(function () { return post(enrollData); })
        .then(finish)
        .catch(function (err) {
          yesBtn.classList.remove('is-loading');
          if (errorEl) {
            errorEl.textContent = err && err.message ? err.message : errorEl.dataset.default;
            errorEl.hidden = false;
          }
        });
    });

    dialog.querySelector('[data-enrollment-no]').addEventListener('click', function () {
      if (!dialog._pf) return;
      dialog._pf.dataset.enrollmentDone = '1';
      dialog.close();
      dialog._pf.submit(); // envío nativo: /cart/add
    });

    dialog.querySelector('[data-enrollment-cancel]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  /* ---------- Pestañas de disciplinas ---------- */
  function initDisciplineSheets() {
    var sheets = document.querySelectorAll('[data-sheet]');
    if (!sheets.length) return;
    var lastTrigger = null;
    var open = function (sheet, trigger) {
      if (!sheet || typeof sheet.showModal !== 'function' || sheet.open) return;
      lastTrigger = trigger || null;
      sheet.showModal();
      document.body.classList.add('no-scroll');
      var hash = sheet.getAttribute('data-sheet-hash');
      if (hash && history.replaceState) history.replaceState(null, '', '#' + hash);
    };
    sheets.forEach(function (sheet) {
      if (sheet.dataset.bound) return;
      sheet.dataset.bound = '1';
      var close = function () { if (sheet.open) sheet.close(); };
      sheet.addEventListener('close', function () {
        document.body.classList.remove('no-scroll');
        if (history.replaceState && location.hash === '#' + sheet.getAttribute('data-sheet-hash')) history.replaceState(null, '', location.pathname + location.search);
        if (lastTrigger) lastTrigger.focus();
      });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
      sheet.querySelectorAll('[data-sheet-close], [data-sheet-close-link]').forEach(function (el) { el.addEventListener('click', close); });
    });
    document.querySelectorAll('[data-sheet-open]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () { open(document.getElementById(btn.getAttribute('data-sheet-open')), btn); });
    });
    // Abrir desde enlace con #wrestling o #grappling
    var fromHash = function () {
      var h = decodeURIComponent(location.hash.replace('#', ''));
      if (!h) return;
      sheets.forEach(function (s) { if (s.getAttribute('data-sheet-hash') === h) open(s); });
    };
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  /* ---------- Donaciones: monto libre ---------- */
  function initDonations() {
    document.querySelectorAll('[data-donate]').forEach(function (root) {
      var form = root.querySelector('[data-donate-form]');
      if (!form || form.dataset.bound) return;
      form.dataset.bound = '1';
      var input = form.querySelector('[data-donate-input]');
      var err = form.querySelector('[data-donate-error]');
      var unit = parseInt(root.dataset.unit, 10) || 1;
      var min = parseInt(root.dataset.min, 10) || unit;
      var variant = root.dataset.variant; // string: no se convierte a Number
      var base = root.dataset.root || '/';
      var fmt = function (n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
      input.addEventListener('input', function () {
        var digits = input.value.replace(/\D/g, '');
        input.value = digits ? fmt(parseInt(digits, 10)).slice(1) : '';
        if (err) err.hidden = true;
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var amount = parseInt(input.value.replace(/\D/g, ''), 10) || 0;
        if (amount < min) {
          if (err) { err.textContent = 'El monto mínimo es ' + fmt(min) + '.'; err.hidden = false; }
          input.focus();
          return;
        }
        var qty = Math.ceil(amount / unit);
        window.location.href = base + 'cart/' + variant + ':' + qty;
      });
    });
  }

  /* ---------- Aparición suave ---------- */
  function initReveal() {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var els = document.querySelectorAll('.section__head, .plan, .annual, .discipline, .club__inner, .class-card');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }

  /* ---------- Login: recuperar contraseña ---------- */
  function initRecover() {
    var recover = document.getElementById('RecoverForm');
    var login = document.getElementById('LoginForm');
    if (!recover || !login) return;
    var show = function (r) { recover.hidden = !r; login.hidden = r; };
    if (window.location.hash === '#recover') show(true);
    document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(recover.hidden); });
    });
  }

  function initContactPrefill() {
    var body = document.getElementById('ContactBody');
    if (!body) return;
    var setMsg = function (msg) { if (msg && !body.value.trim()) body.value = msg; };
    document.querySelectorAll('[data-prefill]').forEach(function (a) {
      if (a.dataset.bound) return; a.dataset.bound = '1';
      a.addEventListener('click', function () { setMsg(a.getAttribute('data-prefill')); setTimeout(function () { var n = document.getElementById('ContactName'); if (n) n.focus({ preventScroll: true }); }, 400); });
    });
    var q = new URLSearchParams(location.search).get('consulta');
    var msgs = { 'primera-clase': body.dataset.msgFirst, 'school-of-wrestling': body.dataset.msgSow };
    if (q && msgs[q]) setMsg(msgs[q]);
  }

  function initPromo() {
    var d = document.querySelector('[data-promo]');
    if (!d || typeof d.showModal !== 'function' || d.dataset.bound) return;
    d.dataset.bound = '1';
    var key = d.getAttribute('data-promo-key') || 'promo';
    var seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (seen) return;
    var close = function () { if (d.open) d.close(); };
    d.addEventListener('close', function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} });
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.querySelectorAll('[data-promo-close]').forEach(function (b) { b.addEventListener('click', close); });
    d.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} }); });
    var delay = (parseInt(d.getAttribute('data-promo-delay'), 10) || 4) * 1000;
    setTimeout(function () {
      if (document.querySelector('dialog[open]')) return;
      d.showModal();
      var btn = d.querySelector('.promo__btn'); if (btn) btn.focus({ preventScroll: true });
    }, delay);
  }




  function initPrivateLessons() {
    var root = document.querySelector('[data-private-lessons]');
    var cfgEl = root && root.querySelector('[data-pl-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var DAYS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var dur = Number(cfg.slotMinutes) || 60;
    var minN = Number(cfg.min) || 4, maxN = Number(cfg.max) || 12;
    var state = { coach: 0, day: null, picked: [] };
    var cal = root.querySelector('[data-cal]'), slotsEl = root.querySelector('[data-slots]');
    var pickedEl = root.querySelector('[data-picked]'), emptyEl = root.querySelector('[data-empty]');
    var countEl = root.querySelector('[data-count]'), totalEl = root.querySelector('[data-total]');
    var meter = root.querySelector('[data-meter]'), buy = root.querySelector('[data-buy]');
    var msg = root.querySelector('[data-msg]'), policy = root.querySelector('[data-policy]');
    var sumCoach = root.querySelector('[data-sum-coach]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function money(c) {
      var a = (Number(c) || 0) / 100, fmt = cfg.money || '${{amount}}';
      var noDec = Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var noDecComma = Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals_with_period_separator' || k === 'amount_no_decimals_with_space_separator') return noDec;
        if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return noDecComma;
        if (k === 'amount_with_comma_separator') return a.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return a.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
    }
    function parseSchedule(txt) {
      var map = {};
      String(txt || '').split(/\n/).forEach(function (line) {
        var parts = line.split('|'); if (parts.length < 2) return;
        var days = [];
        parts[0].split(',').forEach(function (d) {
          d = d.trim(); var r = d.split('-');
          if (r.length === 2) { for (var i = Number(r[0]); i <= Number(r[1]); i++) days.push(i % 7); } else if (d) days.push(Number(d) % 7);
        });
        var ranges = parts[1].split(',').map(function (r) { var x = r.trim().split('-'); return x.length === 2 ? [x[0].trim(), x[1].trim()] : null; }).filter(Boolean);
        days.forEach(function (d) { map[d] = (map[d] || []).concat(ranges); });
      });
      return map;
    }
    function toMin(t) { var x = t.split(':'); return Number(x[0]) * 60 + Number(x[1] || 0); }
    function coach() { return cfg.coaches[state.coach] || {}; }
    function bookedSet() { var s = {}; String(coach().booked || '').split(/\n/).forEach(function (l) { l = l.trim(); if (l) s[l] = true; }); return s; }
    function slotsFor(date) {
      var sched = parseSchedule(coach().schedule), ranges = sched[date.getDay()] || [], out = [], booked = bookedSet();
      var limit = Date.now() + (Number(cfg.minHours) || 0) * 3600000;
      ranges.forEach(function (r) {
        for (var m = toMin(r[0]); m + dur <= toMin(r[1]); m += dur) {
          var dt = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Math.floor(m / 60), m % 60);
          var key = ymd(dt) + ' ' + pad(dt.getHours()) + ':' + pad(dt.getMinutes());
          out.push({ key: key, time: pad(dt.getHours()) + ':' + pad(dt.getMinutes()), date: dt, ok: dt.getTime() >= limit && !booked[key] });
        }
      });
      return out;
    }
    function label(dt) { return DAYS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MONTHS[dt.getMonth()] + ' · ' + pad(dt.getHours()) + ':' + pad(dt.getMinutes()); }
    function renderCal() {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var start = new Date(today); start.setDate(today.getDate() - ((today.getDay() + 6) % 7));
      var end = new Date(today); end.setDate(today.getDate() + (Number(cfg.weeks) || 4) * 7);
      var html = '<div class="cal__head">' + ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map(function (d) { return '<span>' + d + '</span>'; }).join('') + '</div><div class="cal__grid">';
      var d = new Date(start), lastMonth = -1;
      while (d < end || d.getDay() !== 1) {
        var inRange = d >= today && d < end, free = inRange ? slotsFor(d).filter(function (s) { return s.ok; }).length : 0;
        var key = ymd(d), sel = state.day === key, chosen = state.picked.some(function (p) { return p.key.indexOf(key) === 0; });
        var mLabel = d.getMonth() !== lastMonth && inRange ? '<small>' + MONTHS[d.getMonth()] + '</small>' : '';
        if (inRange) lastMonth = d.getMonth();
        html += '<button type="button" class="cal__day' + (free ? ' is-free' : '') + (sel ? ' is-sel' : '') + (chosen ? ' has-pick' : '') + '" data-day="' + key + '"' + (free ? '' : ' disabled') + ' aria-label="' + DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + '">' + mLabel + '<b>' + d.getDate() + '</b>' + (free ? '<i>' + free + ' h</i>' : '') + '</button>';
        d.setDate(d.getDate() + 1);
      }
      cal.innerHTML = html + '</div>';
    }
    function renderSlots() {
      if (!state.day) { slotsEl.innerHTML = '<p class="agenda__hint">' + cfg.i18n.pickDay + '</p>'; return; }
      var p = state.day.split('-'), date = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      var list = slotsFor(date);
      var head = '<p class="agenda__dayname">' + DAYS[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS[date.getMonth()] + '</p>';
      if (!list.some(function (s) { return s.ok; })) { slotsEl.innerHTML = head + '<p class="agenda__hint">' + cfg.i18n.noSlots + '</p>'; return; }
      slotsEl.innerHTML = head + '<div class="slot__grid">' + list.map(function (s) {
        var on = state.picked.some(function (x) { return x.key === s.key; });
        return '<button type="button" class="slot' + (on ? ' is-on' : '') + '" data-slot="' + s.key + '"' + (s.ok ? '' : ' disabled') + ' aria-pressed="' + on + '">' + s.time + '</button>';
      }).join('') + '</div>';
    }
    function renderSummary() {
      var n = state.picked.length;
      state.picked.sort(function (a, b) { return a.key < b.key ? -1 : 1; });
      sumCoach.textContent = coach().name || '';
      pickedEl.innerHTML = state.picked.map(function (p) { return '<li><span>' + p.label + '</span><button type="button" data-unpick="' + p.key + '" aria-label="' + cfg.i18n.remove + '">×</button></li>'; }).join('');
      emptyEl.hidden = n > 0;
      countEl.textContent = (n >= minN ? cfg.i18n.ready : cfg.i18n.count).replace('{n}', n).replace('{min}', minN);
      countEl.classList.toggle('is-ok', n >= minN);
      meter.style.width = Math.min(100, n / minN * 100) + '%';
      totalEl.textContent = money(n * cfg.price);
      buy.disabled = n < minN || !coach().variant || coach().available === false;
    }
    function all() { renderCal(); renderSlots(); renderSummary(); }
    function setCoach(i) {
      if (i === state.coach) return;
      state.coach = i; state.day = null; state.picked = [];
      root.querySelectorAll('[data-coach]').forEach(function (b) { var on = Number(b.getAttribute('data-coach')) === i; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
      all();
    }
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-coach]'))) { setCoach(Number(t.getAttribute('data-coach'))); return; }
      if ((t = e.target.closest('[data-pick-coach]'))) { setCoach(Number(t.getAttribute('data-pick-coach'))); return; }
      if ((t = e.target.closest('[data-day]'))) { state.day = t.getAttribute('data-day'); renderCal(); renderSlots(); return; }
      if ((t = e.target.closest('[data-slot]'))) {
        var key = t.getAttribute('data-slot'), idx = -1;
        state.picked.forEach(function (p, i) { if (p.key === key) idx = i; });
        msg.textContent = '';
        if (idx > -1) state.picked.splice(idx, 1);
        else if (state.picked.length >= maxN) { msg.textContent = cfg.i18n.max; return; }
        else { var p = key.split(/[- :]/); state.picked.push({ key: key, label: label(new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), Number(p[3]), Number(p[4]))) }); }
        renderCal(); renderSlots(); renderSummary(); return;
      }
      if ((t = e.target.closest('[data-unpick]'))) { var k = t.getAttribute('data-unpick'); state.picked = state.picked.filter(function (p) { return p.key !== k; }); all(); return; }
    });
    buy.addEventListener('click', function () {
      msg.textContent = '';
      if (policy && !policy.checked) { msg.textContent = cfg.i18n.policyMsg; policy.focus(); return; }
      var c = coach(), rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      buy.disabled = true;
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(c.variant), quantity: state.picked.length, properties: { 'Coach': c.name, 'Clases': state.picked.map(function (p) { return p.label; }).join(' | '), '_agenda': state.picked.map(function (p) { return p.key; }).join(', ') } }] }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = rootUrl + 'checkout'; })
        .catch(function () { msg.textContent = cfg.i18n.error; buy.disabled = false; });
    });
    all();
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var dlg = g.querySelector('[data-lightbox]'); var img = g.querySelector('[data-lb-img]');
      if (!dlg || !img || typeof dlg.showModal !== 'function') return;
      g.querySelectorAll('[data-full]').forEach(function (b) {
        b.addEventListener('click', function () { img.src = b.getAttribute('data-full'); img.alt = b.getAttribute('aria-label') || ''; dlg.showModal(); });
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-lb-close]')) dlg.close(); });
    });
  }

  function initCampAddons() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function add(items) {
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }
    document.querySelectorAll('[data-camp-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var picks = form.querySelectorAll('[data-addon]:checked');
        if (!picks.length) return;
        e.preventDefault();
        var items = [{ id: Number(form.getAttribute('data-main-id')), quantity: 1 }];
        picks.forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
        var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
        add(items).then(function () { window.location.href = root + 'checkout'; })
          .catch(function () { if (btn) btn.disabled = false; form.submit(); });
      });
    });
    document.querySelectorAll('[data-addon-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.textContent; btn.disabled = true;
        add([{ id: Number(btn.getAttribute('data-addon-add')), quantity: 1 }]).then(function () {
          btn.textContent = btn.getAttribute('data-done') || 'OK'; btn.classList.add('is-done');
          var wrap = btn.closest('.addons'); var link = wrap && wrap.querySelector('[data-addons-cart]'); if (link) link.hidden = false;
          setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-done'); }, 2500);
        }).catch(function () { btn.disabled = false; });
      });
    });
  }

  function initCampGuide() {
    document.querySelectorAll('[data-cx-tabs]').forEach(function (wrap) {
      if (wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var days = Array.prototype.slice.call(wrap.querySelectorAll('.cx-day'));
      if (days.length < 2) return;
      var bar = document.createElement('div'); bar.className = 'cx-tabs'; bar.setAttribute('role', 'tablist');
      var today = new Date(); var iso = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
      var start = 0;
      var tabs = days.map(function (d, i) {
        var label = (d.getAttribute('data-day') || ('Día ' + (i + 1))).split(' ');
        var b = document.createElement('button'); b.type = 'button'; b.className = 'cx-tab'; b.setAttribute('role', 'tab');
        b.innerHTML = '<small>' + label[0] + '</small><b>' + (label[1] || '') + '</b>';
        if (d.classList.contains('cx-day--final')) b.classList.add('is-final');
        if (d.getAttribute('data-date') === iso) { b.classList.add('is-today'); start = i; }
        b.addEventListener('click', function () { show(i, true); });
        bar.appendChild(b); return b;
      });
      function show(i, focus) {
        days.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        if (focus) tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      bar.addEventListener('keydown', function (e) {
        var cur = tabs.indexOf(document.activeElement); if (cur < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = (cur + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; show(n, true); tabs[n].focus(); }
      });
      wrap.parentNode.insertBefore(bar, wrap); wrap.classList.add('is-tabbed'); show(start, false);
    });
    document.querySelectorAll('[data-cx-countdown], [data-cx-event]').forEach(function (el) {
      var startAt = new Date(el.getAttribute('data-cx-countdown') || el.getAttribute('data-cx-event')).getTime();
      var nm = el.getAttribute('data-cx-name') || 'el Camp'; var Nm = nm.charAt(0).toUpperCase() + nm.slice(1);
      var endAt = new Date(el.getAttribute('data-cx-end') || el.getAttribute('data-cx-countdown') || el.getAttribute('data-cx-event')).getTime();
      var now = Date.now(); var dayMs = 86400000;
      if (isNaN(startAt)) return;
      if (now < startAt) { var d = Math.ceil((startAt - now) / dayMs); el.textContent = d === 1 ? 'Falta 1 día para ' + nm : 'Faltan ' + d + ' días para ' + nm; }
      else if (now <= endAt) { el.textContent = Nm + ' está en curso'; }
      else { el.textContent = 'Evento finalizado · ¡Gracias por ser parte!'; }
    });
    var nav = document.querySelector('.cx-nav');
    if (nav && 'IntersectionObserver' in window && !nav.dataset.bound) {
      nav.dataset.bound = '1';
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      links.forEach(function (a) { a.addEventListener('click', function (e) { var t = document.querySelector(a.getAttribute('href')); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', a.getAttribute('href')); }); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); }); } });
      }, { rootMargin: '-40% 0px -55% 0px' });
      links.forEach(function (a) { var t = document.querySelector(a.getAttribute('href')); if (t) io.observe(t); });
    }
  }

  function init() {
    initCampGuide();
    initCampAddons();
    initGallery();
    initPrivateLessons();
    initContactPrefill();
    initPromo();
    initHeader();
    initHero();
    initSchedules();
    initVariantSelects();
    initEnrollment();
    initDonations();
    initDisciplineSheets();
    initReveal();
    initRecover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: re-inicializar al editar secciones.
  document.addEventListener('shopify:section:load', function () {
    initHero();
    initSchedules();
    initVariantSelects();
    initEnrollment();
    initDonations();
    initDisciplineSheets();
  });
})();
